/**
 * Platform Admin App
 */

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";
import { theme } from "./theme";
import { Layout } from "./components/layout";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import {
  LoginPage,
  DashboardPage,
  TenantsPage,
  TenantDetailPage,
  CreateTenantPage,
  ModulesPage,
  FeatureFlagsPage,
  PlatformUsersPage,
  BillingPage,
  TemplateSeedingPage,
} from "./pages";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          autoHideDuration={4000}
        >
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<DashboardPage />} />
                <Route path="tenants" element={<TenantsPage />} />
                <Route path="tenants/new" element={<CreateTenantPage />} />
                <Route path="tenants/:id" element={<TenantDetailPage />} />
                <Route path="modules" element={<ModulesPage />} />
                <Route path="billing" element={<BillingPage />} />
                <Route path="feature-flags" element={<FeatureFlagsPage />} />
                <Route path="users" element={<PlatformUsersPage />} />
                <Route path="templates" element={<TemplateSeedingPage />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
